import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/pro-duotone-svg-icons";
import Popup from '@controls/Popup';
import PunchReportList from '@components/punch/report/PunchReportList';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import styles from '@styles/punch.module.css';
import * as storage from '@utils/storage'

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

export default function PunchReportRoot(props) {
    const classes = useStyles();

    const { punchId, isEnabled } = props;

    const [openPop, setOpenPop] = useState(false);
    const [useDailyReport, setUseDailyReport] = React.useState(storage.getUseDailyReport());
    const [useEventReport, setUseEventReport] = React.useState(storage.getUseEventReport());

    const handleOpenListReport = () => {
        setOpenPop(true);
    }

    const handleClosePop = () => {
        setOpenPop(false);
    }

    return (
        (useDailyReport || useEventReport) && (<div>
            <FormControl>
                <Button
                    className={styles.punchReportButton}
                    color="primary"
                    onClick={handleOpenListReport}
                    endIcon={<FontAwesomeIcon icon={faFileLines} />}
                >
                    {i18next.t('punch:report.title')}
                </Button>
            </FormControl>

            {/*<IconButton className={classes.icons} edge="end" aria-label="delete" onClick={handleOpenListReport}>*/}
            {/*    <FontAwesomeIcon icon={faFileLines} style={{ width: "20px", height: "20px", marginRight: "5px" }} />*/}
            {/*</IconButton>*/}
            <Popup title={i18next.t('punch:report.title')} openPop={openPop} handleClosePop={handleClosePop}>
                <PunchReportList punchId={punchId} isEnabled={isEnabled} />
            </Popup>
        </div>)
    )
}